import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { PrimaryButton, SecondaryButton } from '../button/Button.jsx';
import './AccessStatusCard.css';

const ACTION_BUTTONS = { primary: PrimaryButton, secondary: SecondaryButton };

/**
 * Shared access-status card — one consistent look for every "your access state" surface: the
 * org-join waiting screen (Access Pending / Access granted), the dashboard "no game access"
 * placeholder, and the My-Access-Requests subtab. Mirrors the "Access Suspended" card on the
 * not-authorized page: a centered card with a round status-icon badge on top, a title, a message,
 * and an optional action button (rendered with the app's standard Primary/Secondary button).
 *
 * @param {Object} props
 * @param {'info'|'success'|'danger'} [props.tone='info']  badge colour (status semantics)
 * @param {Object} props.icon                FontAwesome icon (faCircleInfo / faCircleCheck …)
 * @param {string} props.title
 * @param {React.ReactNode} props.message
 * @param {React.ReactNode} [props.children]  optional extra content rendered under the message
 * @param {Object} [props.action]            { label, busyLabel?, busy?, onClick, icon?, variant? }
 */
const AccessStatusCard = ({ tone = 'info', icon, title, message, children, action }) => {
    const ActionButton = action ? (ACTION_BUTTONS[action.variant] || PrimaryButton) : null;
    return (
        <div className="access-status-card" role="status">
            <div className={`access-status-card-badge access-status-card-badge--${tone}`}>
                <FontAwesomeIcon icon={icon} />
            </div>
            <h2 className="access-status-card-title">{title}</h2>
            <p className="access-status-card-text">{message}</p>
            {children}
            {action && (
                <ActionButton
                    icon={action.icon}
                    loading={!!action.busy}
                    onClick={action.onClick}
                >
                    {action.busy && action.busyLabel ? action.busyLabel : action.label}
                </ActionButton>
            )}
        </div>
    );
};

export default AccessStatusCard;
